<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
html, body, #app {
  height: 100%;
  min-width: 1910px;
  background: #141414;

  .ant-menu {
    background: #141414;
    color: #4C8EFF;
    font-weight: bold;
    font-size: 13px;
  }

  .ant-menu-item, .ant-menu-submenu-title {
    padding-top: 2px;
    font-weight: 400;
  }

  .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow, .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
    right: auto;
    margin-left: 5px;
    visibility: hidden;
  }


  .ant-menu-horizontal {
    border-bottom: 1px solid #141414;
  }

  .ant-menu-submenu > .ant-menu {
    background: #4C8EFF;
    border-radius: 0;
    color: #FFFFFF;
  }

  .ant-menu-submenu :last-child > .ant-menu {
    background: #5E9AFF;
  }

  .ant-menu-submenu :hover {
    color: #ffffff;
  }

  .ant-menu-item:hover, .ant-menu-item-active, .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open, .ant-menu-submenu-active {
    background-color: #4C8EFF;
    color: #FFFFFF;

  }

  .ant-menu-horizontal > .ant-menu-item:hover, .ant-menu-horizontal > .ant-menu-submenu:hover, .ant-menu-horizontal > .ant-menu-item-active, .ant-menu-horizontal > .ant-menu-submenu-active, .ant-menu-horizontal > .ant-menu-item-open, .ant-menu-horizontal > .ant-menu-submenu-open, .ant-menu-horizontal > .ant-menu-item-selected, .ant-menu-horizontal > .ant-menu-submenu-selected {
    border-bottom: 2px solid #4C8EFF;
  }


  .ant-menu-dark, .ant-menu-dark .ant-menu-sub {
    background: #4C8EFF;
    color: #4C8EFF;
  }

  .ant-menu-submenu-popup {
    min-width: 270px;
    background: #4C8EFF;
    color: #FFFFFF;
  }

  .ant-menu.ant-menu-dark .ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
    background-color: transparent;
  }

  .ant-menu-dark .ant-menu-item:hover {
    background: #4C8EFF;
    color: #FFFFFF;
  }

  .ant-menu-horizontal > .ant-menu-item-selected, .ant-menu-menu:hover, .ant-menu-horizontal > .ant-menu-item.active, .ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {
    background: #4C8EFF;
    color: #FFFFFF;
  }

  .ant-menu-submenu-title:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .ant-menu-item:hover, .ant-menu-item-active {
    background-color: rgba(255, 255, 255, 0.2);
    color: #FFFFFF;
  }

  .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before, .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after, .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
    background: #FFFFFF;
  }

  .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before, .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before, .ant-menu-submenu-vertical > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical-left > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-submenu-vertical-right > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after {
    background: #FFFFFF;
  }

  .ant-input {
    max-width: 481px;
    height: 40px;
    background: #141414;
    border: 1px solid #4C8EFF;
    color: #4C8EFF;
  }

  .ant-cascader-picker-arrow {
    color: #4C8EFF;
  }

  .ant-cascader-picker-clear {
    color: #4C8EFF;
    background: none;
  }


  .ant-cascader-picker {
    max-width: 481px;
    height: 40px;
    background: #141414;
    color: #4C8EFF;
  }


  .ant-cascader-menus {
    background: #141414;
    color: white;
    border: 1px solid #4C8EFF;
  }

  .ant-cascader-menu {
    border-right: 1px solid #4C8EFF;
  }

  .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled), .ant-cascader-menu-item-active:not(.ant-cascader-menu-item-disabled):hover {
    background-color: #4C8EFF;
    color: white;
  }

  .ant-cascader-menu-item-expand .ant-cascader-menu-item-expand-icon, .ant-cascader-menu-item-loading-icon {
    color: white;
  }

  .ant-cascader-menu-item:hover {
    background-color: #98b3e0;
  }

  .ant-input[placeholder="Please select"]::placeholder {
    color: #4C8EFF;
  }

  .ant-menu-dark.ant-menu-horizontal > .ant-menu-item, .ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
    width: 120px;
  }

  /* 设置ant-cascader 滚动条*/

  .ant-cascader-menu::-webkit-scrollbar {
    width: 3px;
  }

  .ant-cascader-menu::-webkit-scrollbar-thumb {
    background-color: #4C8EFF;
  }

  .ant-cascader-menu::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  /* 设置详情 滚动条*/

  .ant-carousel .slick-dots::-webkit-scrollbar {
    height: 6px;

  }

  .ant-carousel .slick-dots::-webkit-scrollbar-thumb {
    background-color: #4C8EFF;
    border-radius: 2px;
    cursor: pointer;
  }

  .ant-carousel .slick-dots::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 0 0 2px 2px;
  }
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #141414;
  color: #4C8EFF;

}

html::-webkit-scrollbar {
  width: 5px;

}

html::-webkit-scrollbar-thumb {
  background-color: #8dabe2;
  cursor: pointer;
}

html::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  cursor: pointer;
}

</style>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue